import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AdaptStorageModule } from "@common/storage/storage.module";
import { AdaptLoadingSpinnerModule } from "@common/ux/loading-spinner/loading-spinner.module";
import { WorkflowService } from "@org-common/lib/workflow/workflow.service";
import { DxTextBoxModule, DxValidationGroupModule, DxValidatorModule } from "devextreme-angular";
import { SetUpProfileComponent } from "./onboarding/set-up-profile/set-up-profile.component";
import { Workflows } from "./workflows";


@NgModule({
    imports: [
        CommonModule,
        AdaptStorageModule,
        DxTextBoxModule,
        DxValidationGroupModule,
        DxValidatorModule,
        AdaptLoadingSpinnerModule,
    ],
    declarations: [
        SetUpProfileComponent,
    ],
})
export class AdaptCumulusWorkflowsModule {
    // prevent being optimised by tree-shaker
    public readonly workflowStepComponents = [
        SetUpProfileComponent,
    ];

    public constructor(workflowService: WorkflowService) {
        workflowService.setLocalWorkflows(Object.values(Workflows));
    }
}
